(function () {
  function fit() {
    const el = document.querySelector('.collection-banner__title');
    if (!el) return;
    el.style.fontSize = '';
    const natural = parseFloat(getComputedStyle(el).fontSize);
    const max = el.parentElement.offsetWidth;
    if (el.scrollWidth <= max) return;
    let size = natural;
    while (el.scrollWidth > max && size > 10) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }
  document.addEventListener('DOMContentLoaded', fit);
  window.addEventListener('resize', fit);
})();